// =============================================================================
// JUGO Quiz — Data Layer (Shopify port — image paths via )
// Mirrors /Users/nam8/jugo quiz/quiz/data.js — keep in sync if logic changes.
// =============================================================================

// Free-gift images (unlocked by jar count: freshener@2, tote@4, hat@6).
const QUIZ_GIFTS = {
  freshener: '//jugobrands.com/cdn/shop/t/75/assets/jugo-byob-gift-freshener.webp?v=169169220616707557681790036007',
  tote:      '//jugobrands.com/cdn/shop/t/75/assets/jugo-byob-gift-tote.webp?v=35942168456228085821790036007',
  hat:       '//jugobrands.com/cdn/shop/t/75/assets/jugo-byob-gift-hat.webp?v=128074134878113150601790036016',
};
// Floating gummy decorations for the quiz chrome.
const QUIZ_GUMMIES = [
  '//jugobrands.com/cdn/shop/t/75/assets/jugo-header-gummy-energy.webp?v=90492369329420128701790036016',
  '//jugobrands.com/cdn/shop/t/75/assets/jugo-header-gummy-beauty.webp?v=109288481344517552511790036016',
  '//jugobrands.com/cdn/shop/t/75/assets/jugo-header-gummy-focus.webp?v=148623584067375463691790036016',
  '//jugobrands.com/cdn/shop/t/75/assets/jugo-header-gummy-acv.webp?v=6213129670358675991790036003',
];
// Lifestyle photography + press for the result page.
const QUIZ_PHOTOS = {
  fam:   '//jugobrands.com/cdn/shop/t/75/assets/jugo-lifestyle-friends-guitar.jpg?v=70086413029815039631790036011',
  woman: '//jugobrands.com/cdn/shop/t/75/assets/jugo-lifestyle-woman-bottle.jpg?v=176082825504919373301790036012',
};
const QUIZ_PRESS = [
  { src: '//jugobrands.com/cdn/shop/t/75/assets/jugo-press-prime.png?v=29322461148991094371790036011',     name: 'Prime Real Estate Magazine', cls: 'rz-press--prime' },
  { src: '//jugobrands.com/cdn/shop/t/75/assets/jugo-press-stylelujo.png?v=83110745978274994971790036009', name: 'StyleLujo',                   cls: 'rz-press--sl' },
  { src: '//jugobrands.com/cdn/shop/t/75/assets/jugo-press-dailymom.png?v=71344066228785199121790036011',  name: 'Daily Mom',                   cls: 'rz-press--dm' },
];
// Story-section art for the result page (real brand illustrations + photos + retailer logos).
const QUIZ_STORY = {
  superfruit: '//jugobrands.com/cdn/shop/t/75/assets/jugo-pdp-focus-broll-superfruits.webp?v=36970645666635642851790036012',
  life:       '//jugobrands.com/cdn/shop/t/75/assets/jugo-lifestyle-beachcar-laugh.jpg?v=139237110394871392191790036012',
  fruit:      '//jugobrands.com/cdn/shop/t/75/assets/jugo-kids-decor-fruit.png?v=153310707698768116511790036015',
  palm:       '//jugobrands.com/cdn/shop/t/75/assets/jugo-kids-decor-palm-gold.png?v=60820472859795710211790036016',
  hibiscus:   '//jugobrands.com/cdn/shop/t/75/assets/jugo-kids-decor-hibiscus.png?v=179175479505915054341790036006',
  leaves:     '//jugobrands.com/cdn/shop/t/75/assets/jugo-kids-decor-leaves.png?v=174917056699213086101790036007',
  retailers: [
    '//jugobrands.com/cdn/shop/t/75/assets/jugo-pdp-acv-logo-wholefoods.png?v=69926850743777454941790036011',
    '//jugobrands.com/cdn/shop/t/75/assets/jugo-pdp-acv-logo-vons.png?v=75043515100614041341790036011',
    '//jugobrands.com/cdn/shop/t/75/assets/jugo-pdp-acv-logo-bristolfarms.png?v=38185346175232014621790036011',
    '//jugobrands.com/cdn/shop/t/75/assets/jugo-pdp-acv-logo-gelsons.png?v=75611815786895033201790036007'
  ],
};

const PRODUCTS = {
  energy: {
    id: 'energy',
    name: 'JUGO Energy',
    tagline: 'Caffeine-free energy that lasts',
    image: '//jugobrands.com/cdn/shop/t/75/assets/jugo-byob-product-energy.png?v=50767813589736244031790036019',
    audience: 'adult',
    hero_ingredients: 'Full B-complex (B12 at 3,125% DV) + organic supergreen blend',
    msrp: 19.99,
    default_role: 'The fuel layer — clean, steady energy that carries the whole day.',
    signature_ingredient: 'organic greens',
    why_ingredients: ['organic kale', 'spirulina', 'chlorella'],
    hero_dose: '3,125% DV B12',
    layer: { type: 'responsive', name: 'energy' },
    axis_label: 'steady fuel (B-vitamins from organic greens)',
    role_for: {
      fatigue: 'Energy that lasts is built on a strong B-complex floor. 3,125% DV B12 + a full B-complex give your body exactly what it runs on.',
      caffeine_crash: 'Real energy comes from building fuel, not borrowing it from cortisol. B-vitamins + adaptogenic greens give you the cleaner, steadier kind that never asks for a third coffee.',
      wired_tired: 'Calm, grounded energy is a B-vitamin and absorption story — and this is built to deliver exactly that.',
      fog: 'A clear, switched-on afternoon runs on B12. 3,125% DV here is a clinical dose — the real thing, not a sprinkle.',
      sluggish: 'When you want to feel light and switched-on, the supergreen blend (chlorella, spirulina, kale, wheatgrass) is the cellular wake-up.',
    },
  },
  focus: {
    id: 'focus',
    name: 'JUGO Focus',
    tagline: 'Calm head, sharper focus',
    image: '//jugobrands.com/cdn/shop/t/75/assets/jugo-byob-product-focus.png?v=126808535233158406171790036016',
    audience: 'adult',
    hero_ingredients: 'Ashwagandha 300mg + Vitamin D3 + Superfruit antioxidant blend',
    msrp: 19.99,
    default_role: 'The calm-and-clear layer — a quieter mind with a steadier floor underneath.',
    signature_ingredient: 'ashwagandha',
    why_ingredients: ['ashwagandha', 'superfruit antioxidants'],
    hero_dose: '300mg of real ashwagandha root extract',
    layer: { type: 'responsive', name: 'mood support' },
    axis_label: 'a calm stress response (steady cortisol)',
    role_for: {
      stress: 'Calm is chemistry, not willpower. 300mg is the exact dose ashwagandha was studied at for stress support — the real clinical amount, not a sprinkle on the label.',
      anxiety: 'A quieter head comes from steadier cortisol. Ashwagandha helps bring it down; D3 keeps mood on an even keel.',
      fog: 'Clarity is less about rest and more about easing the overload. Ashwagandha + D3 is the layer that clears the way.',
      sleep: 'Better sleep often starts with calmer daytime cortisol. Take this in the morning — many people say sleep is the first thing they notice improve.',
      edge: 'More patience, less edge — that\'s exactly what ashwagandha + D3 deliver, biochemically.',
      wired_tired: 'Calm-and-energized comes from settling the stress hormones. This is the gentle reset.',
    },
  },
  beauty: {
    id: 'beauty',
    name: 'JUGO Beauty',
    tagline: 'Hair, Skin & Nails',
    image: '//jugobrands.com/cdn/shop/t/75/assets/jugo-byob-product-beauty.png?v=10094932213696368281790036015',
    audience: 'adult',
    hero_ingredients: 'Biotin 2,500mcg (8,333% DV) + Collagen + Hyaluronic Acid + Turmeric',
    msrp: 19.99,
    default_role: 'The visible-results layer — rewarding consistency on a 90-day clock.',
    signature_ingredient: 'turmeric',
    why_ingredients: ['turmeric', 'collagen'],
    hero_dose: '8,333% DV biotin',
    layer: { type: 'slow-burn', name: 'skin and hair' },
    axis_label: "visible recovery (your skin and hair reflect what you feed them)",
    role_for: {
      hair: 'Biotin at 8,333% DV plus collagen peptides is the real protocol for fuller, stronger hair — well beyond the 100% DV most gummies stop at.',
      skin: 'Hyaluronic acid + turmeric work from the inside out. Skin renews over months, so this is the patient, long-burn layer of the regimen — and it rewards you for sticking with it.',
      mirror: 'The mirror is the last place results show up — and they do show up. Beauty works quietly in the background and tends to surface around week 8–10.',
      aging: 'Collagen production naturally eases about 1% a year after 25. This is the daily layer that keeps topping that floor back up.',
    },
  },
  acv: {
    id: 'acv',
    name: 'JUGO ACV + B12',
    tagline: 'Gut & metabolism',
    image: '//jugobrands.com/cdn/shop/t/75/assets/jugo-byob-product-acv.png?v=87741321139511523641790036020',
    audience: 'adult',
    hero_ingredients: '500mg Apple Cider Vinegar + B12 (2,083% DV) + Acai',
    msrp: 19.99,
    default_role: 'The gut + metabolism layer — the upstream lever that quietly lifts everything else.',
    signature_ingredient: 'apple cider vinegar',
    why_ingredients: ['apple cider vinegar'],
    hero_dose: '500mg apple cider vinegar',
    layer: { type: 'responsive', name: 'gut' },
    axis_label: 'strong absorption + metabolism (a gut that works with you)',
    role_for: {
      bloat: 'ACV before meals is the most-studied natural route to that light, flat feeling after eating. 500mg is the active dose — the one that actually does the work.',
      gut: 'The gut is the engine that quietly powers everything. Support it and energy + skin both rise downstream.',
      weight: 'When weight feels stuck, it\'s often metabolism rather than calories. ACV + B12 give the metabolic side real support.',
      heavy: 'A light, easy feeling after meals is exactly where this earns its place.',
    },
  },
  kids_daily: {
    id: 'kids_daily',
    name: 'JUGO Kids Daily',
    tagline: 'Multivitamin + superfoods',
    image: '//jugobrands.com/cdn/shop/t/75/assets/jugo-quiz-kid.png?v=172248527583855941871790036011',
    audience: 'kids',
    hero_ingredients: 'Full daily multi + Superfruit & Alkalizing blends',
    msrp: 19.99,
    default_role: 'The daily nutrition floor for your kids — dinner-table peace, handled.',
    signature_ingredient: 'organic superfood blend',
    why_ingredients: ['organic superfood blend'],
    hero_dose: null,
    layer: { type: 'kids', name: "kids' daily floor" },
    axis_label: null,
    role_for: {
      picky: 'Even the pickiest eater gets a solid daily floor — and you get to skip the broccoli negotiation entirely.',
      kids_default: 'One gummy your kid actually wants, that covers a full daily multi. C, D3, zinc, the B-complex — all there.',
    },
  },
  kids_sport: {
    id: 'kids_sport',
    name: 'JUGO Kids Sport',
    tagline: 'Hydration + electrolytes',
    image: '//jugobrands.com/cdn/shop/t/75/assets/jugo-quiz-kids-sport.png?v=111493643423524729871790036003',
    audience: 'kids',
    hero_ingredients: 'Magnesium + Potassium + Sodium electrolytes + B12 + Superfruits',
    msrp: 19.99,
    default_role: 'The hydration + recovery layer — so the active kid finishes the day as strong as they started.',
    signature_ingredient: 'electrolytes + B12',
    why_ingredients: ['electrolytes'],
    hero_dose: null,
    layer: { type: 'kids', name: "kids' hydration" },
    axis_label: null,
    role_for: {
      sports: 'Active kids burn through electrolytes fast. Mg + K + Na + B12 keeps them topped up and going strong.',
      kids_default: 'Practice, games, long school days — this is what helps them finish strong all the way to pickup.',
    },
  },
};

const FILL_ORDER = {
  energy: ['focus', 'acv', 'beauty'],
  focus:  ['energy', 'acv', 'beauty'],
  beauty: ['acv', 'focus', 'energy'],
  acv:    ['energy', 'focus', 'beauty'],
};

const QUESTIONS = [
  {
    id: 'audience',
    eyebrow: 'Question 1 of 7',
    headline: "Who are we building this for?",
    subhead: "Bigger crew, better stack. We'll build around your real life.",
    type: 'single',
    options: [
      { value: 'self',    label: 'Just me',              path: ['adult'] },
      { value: 'couple',  label: 'Me and my partner',    path: ['adult'] },
      { value: 'parent',  label: 'Me, but the kids too', path: ['adult', 'kids'] },
      { value: 'family',  label: 'The whole household',  path: ['adult', 'kids'] },
    ],
  },
  {
    id: 'primary_adult',
    eyebrow: 'Question 2 of 7',
    headline: "What's the ONE thing you'd love to dial in first?",
    subhead: "This is the headline — the rest of the regimen builds around it.",
    type: 'single',
    showIf: (a) => a.audience !== null,
    options: [
      { value: 'energy',  label: 'Energy that stays steady',            score: { energy: 1000 }, pains: ['fatigue'] },
      { value: 'focus',   label: 'A quieter, sharper head',              score: { focus: 1000 },  pains: ['stress', 'fog'] },
      { value: 'beauty',  label: 'Hair, skin & nails I\'m proud of',     score: { beauty: 1000 }, pains: ['hair', 'skin'] },
      { value: 'acv',     label: 'A gut that feels great',              score: { acv: 1000 },    pains: ['bloat', 'gut'] },
    ],
  },
  {
    id: 'primary_kids',
    eyebrow: 'Question 2b',
    headline: "And for the kids — what's the priority?",
    subhead: "Kids get their own answer. The gummies they actually want.",
    type: 'single',
    showIf: (a) => a.audience === 'parent' || a.audience === 'family',
    options: [
      { value: 'daily',  label: 'Daily nutrition that\'s an easy yes',          score: { kids_daily: 1000 }, pains: ['picky'] },
      { value: 'sport',  label: 'Energy + hydration for sports / school',      score: { kids_sport: 1000 }, pains: ['sports'] },
      { value: 'both',   label: 'Honestly, both',                              score: { kids_daily: 1000, kids_sport: 1000 }, pains: ['picky', 'sports'] },
    ],
  },
  {
    id: 'tuesday',
    eyebrow: 'Question 3 of 7',
    headline: "Tuesday, 3pm. The honest version of you is...",
    subhead: "Whatever Tuesday looks like, we've got a stack for it.",
    type: 'single',
    options: [
      { value: 'fumes',   label: 'Running on fumes',                 score: { energy: 60 },                  pains: ['fatigue'] },
      { value: 'wired',   label: 'Wired but exhausted',              score: { focus: 50, energy: 30 },       pains: ['wired_tired'] },
      { value: 'foggy',   label: 'Mentally foggy, can\'t lock in',   score: { focus: 60, energy: 20 },       pains: ['fog'] },
      { value: 'heavy',   label: 'Bloated and heavy',                score: { acv: 60 },                     pains: ['bloat', 'heavy'] },
      { value: 'mirror',  label: 'Not loving what I see in the mirror', score: { beauty: 60, acv: 20 },     pains: ['mirror'] },
      { value: 'solid',   label: 'Honestly, pretty solid — just optimizing', score: { energy: 20, focus: 20, beauty: 20, acv: 20 }, pains: [] },
    ],
  },
  {
    id: 'else',
    eyebrow: 'Question 4 of 7',
    headline: "While we're here — what else would you love to improve?",
    subhead: "The more we know, the better the regimen. Pick anything that's true.",
    type: 'multi',
    options: [
      { value: 'sleep',     label: 'Restless / shallow sleep',          score: { focus: 40 },           pains: ['sleep'] },
      { value: 'bloat',     label: 'Bloat that won\'t quit',            score: { acv: 50 },             pains: ['bloat'] },
      { value: 'hair',      label: 'More hair in the brush than I\'d like', score: { beauty: 50 },     pains: ['hair'] },
      { value: 'skin',      label: 'Skin that needs help',              score: { beauty: 50 },          pains: ['skin'] },
      { value: 'brain_fog', label: 'Brain fog that won\'t clear',       score: { focus: 40, energy: 20 }, pains: ['fog'] },
      { value: 'edge',      label: 'More patience, less edge',          score: { focus: 45 },           pains: ['edge'] },
      { value: 'weight',    label: 'Weight that won\'t move',           score: { acv: 50 },             pains: ['weight'] },
      { value: 'caffeine',  label: 'Off the 3-coffee day',              score: { energy: 50 },          pains: ['caffeine_crash'] },
      { value: 'none',      label: 'Nothing else — just the main thing', score: {},                     pains: [], exclusive: true },
    ],
  },
  {
    id: 'objection',
    eyebrow: 'Question 5 of 7',
    headline: "Real talk — what's gotten in the way of supplements before?",
    subhead: "Whatever tripped you up before, we've already got it handled.",
    type: 'single',
    options: [
      { value: 'forgot',   label: 'I forgot to take them',          tag: 'forgot' },
      { value: 'taste',    label: 'They tasted like punishment',    tag: 'taste' },
      { value: 'nothing',  label: 'I didn\'t feel anything',        tag: 'nothing' },
      { value: 'unclear',  label: 'Couldn\'t tell if they worked',  tag: 'unclear' },
      { value: 'pills',    label: 'Pills feel clinical, depressing', tag: 'pills' },
      { value: 'fresh',    label: 'Haven\'t really tried — fresh start', tag: 'fresh' },
    ],
  },
  {
    id: 'future',
    eyebrow: 'Question 6 of 7',
    headline: "6 weeks from now, the version of you we're building has...",
    subhead: "Dream big — pick everything you'd love to be true.",
    type: 'multi',
    options: [
      { value: 'energy_future', label: 'Steady energy all day',           score: { energy: 25 }, pains: ['fatigue'] },
      { value: 'calm_future',   label: 'A calm, sharp head',              score: { focus: 25 },  pains: ['stress'] },
      { value: 'glow_future',   label: 'Hair and skin people notice',     score: { beauty: 25 }, pains: ['hair', 'skin'] },
      { value: 'flat_future',   label: 'A flat, easy stomach',            score: { acv: 25 },    pains: ['bloat'] },
      { value: 'kids_future',   label: 'Kids who are also handled', score: { kids_daily: 25, kids_sport: 25 }, pains: ['picky'], requiresKidsPath: true },
      { value: 'all_future',    label: 'All of it — let\'s not half-ass this', score: { energy: 30, focus: 30, beauty: 30, acv: 30 }, pains: [], tag: 'maximalist' },
    ],
  },
  {
    id: 'commit',
    eyebrow: 'Question 7 of 7',
    headline: "30 seconds in the morning. Can you commit?",
    subhead: "30 seconds is the whole ritual. Pop, sip, win the day.",
    type: 'single',
    options: [
      { value: 'easy',     label: 'Easy. Done.',                tag: 'committed' },
      { value: 'reminder', label: 'Yes — with a reminder',      tag: 'committed' },
      { value: 'try',      label: 'I want to. Let\'s see.',     tag: 'tentative' },
    ],
  },
];

const REGIMEN_NAMES = {
  energy:      { adult: 'The Engine',        family: 'The Family Engine' },
  focus:       { adult: 'The Quiet Mind',    family: 'The Family Quiet Mind' },
  beauty:      { adult: 'The Glow Protocol', family: 'The Family Glow Protocol' },
  acv:         { adult: 'The Reset',         family: 'The Family Reset' },
  kids_daily:  { adult: 'The Kid Floor',     family: 'The Kid Floor' },
  kids_sport:  { adult: 'The Athlete Kit',   family: 'The Athlete Kit' },
};

const OBJECTION_REVERSALS = {
  forgot:   "**Remembering is the easy part now.** Subscribe ships every 4 weeks on autopilot, so the next bottle is already on the counter waiting for you — the habit takes care of itself. Skip or swap any time.",
  taste:    "**These are the ones you'll actually look forward to.** Real fruit gummies, real superfood flavors — pomegranate, acai, goji, maqui. People treat them like a daily treat, which is exactly the point: the ones you enjoy are the ones you keep taking, and the ones you keep taking are the ones that work.",
  nothing:  "**This time you'll feel the difference.** Most gummies cap at 100% DV with synthetic isolates — easy to miss. JUGO doses are 8,333% DV biotin, 3,125% DV B12, 300mg of real ashwagandha root extract, all sourced from real superfoods. These are doses you can actually feel.",
  unclear:  "**This time you'll see it working.** Most people take one bottle for three weeks and stop, right before the good part. Hair runs on a 90-day cycle. Skin turns over every 60. Mood is the earliest layer to shift. The regimen below is built to carry you all the way through that arc.",
  pills:    "**This feels like a morning ritual, not medicine.** That's exactly why it's a real-fruit gummy built on real superfoods — something you look forward to rather than choke down. The habit is the unlock; the dose is the difference.",
  fresh:    "**Fresh start — the best kind.** Nothing to unlearn, just good habits to build. The regimen below is built from real superfoods (turmeric, ashwagandha, ACV, organic greens, superfruit antioxidants), structured the way your biology actually works — the responsive layers up front (energy, mood support), the slow-burn layers (skin, hair) working quietly in the background.",
};

const WHY_STACK = {
  energy: "Energy gets you up — and energy that lasts leans on a few layers working together: steady fuel (B vitamins), a calm stress response (cortisol kept in check), and a gut that absorbs it all. That's where a regimen does what one bottle can't — it supports all three at once, with real superfoods at clinical doses (organic kale, spirulina, chlorella, ashwagandha, ACV), the real thing rather than synthetic isolates dressed up as gummies.",
  focus:  "Focus calms the head beautifully — and a calm head feels even better with fuel behind it. The regimen pairs real ashwagandha root extract (the OG adaptogen — 3,000 years older than the supplement industry) with B vitamins from organic greens. Calm AND fueled is the real unlock.",
  beauty: "Hair grows in 3 cycles a year; skin turns over every 28 days. Thirty days is one biological cycle — a great start, with the best still ahead. The regimen pairs the visible layer (biotin, collagen, hyaluronic acid, turmeric root) with the upstream layer (gut + calm) — because low-stress, low-inflammation days are when hair and skin look their best. Real superfoods doing the work the way nature already worked it out.",
  acv:    "ACV brings that light, flat feeling — and it goes further when you support what feeds into it: metabolism (B12), a calm inflammation response (superfruit antioxidants — acai, pomegranate, goji), and steady stress levels (cortisol shapes where weight sits). The regimen supports the gut from every angle, all from real food sources — that's why it keeps delivering where one bottle stalls.",
};

const Q4_PHRASES = {
  sleep:     'deeper sleep',
  bloat:     'a lighter middle',
  hair:      'fuller hair',
  skin:      'happier skin',
  brain_fog: 'a clearer head',
  edge:      'more patience',
  weight:    'easier weight management',
  caffeine:  'less reliance on caffeine',
};

const Q3_PHRASES = {
  fumes:  'running on fumes',
  wired:  'wired but exhausted',
  foggy:  'mentally foggy',
  heavy:  'bloated and heavy',
  mirror: 'not loving the mirror',
  solid:  'pretty solid — just optimizing',
};

const COMMIT_FRAMES = {
  committed: "You said you're in — love that. Showing up is the one thing that makes all of this work, and the regimen below is built for someone who does exactly that.",
  tentative: "You said \"let's see\" — totally fair. The subscribe option below is made for exactly that: 4-week ships, skip any time, swap any SKU. No lock-in, just a gentle default that makes the good habit easy to keep.",
};
